import { createChildListViewContainer } from 'factories/ChildListView'
import Component from 'components/Orders/Suppliers'

export default createChildListViewContainer()(Component)
